import { Snackbar, Box } from "@material-ui/core";
import ErrorIcon from "@material-ui/icons/Error";

const AlertComponent = ({ alerts }) => {
  if (alerts && alerts.length > 0) {
    return alerts.map((alert) => (
      <Snackbar
        key={alert.timestamps}
        open
        ContentProps={{
          style: {
            background: "red",
          },
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        message={
          <Box display="flex" alignItems="center">
            <ErrorIcon style={{ marginRight: 8, color: "white" }} />
            {alert.message}
          </Box>
        }
      />
    ));
  }
  return null;
};

export default AlertComponent;
